import { useEffect } from "react";
import { Prompt } from "react-router-dom";
import { useTranslation } from "react-i18next";

const UnsavedChangesWarning = ({hasUnsavedChanges, callBack=()=>{}}) => {
  const { t } = useTranslation();
  useEffect(() => {
    const handleBeforeUnload = (event) => {
      if (!hasUnsavedChanges) return;
      
      callBack();
      event.preventDefault();
      event.returnValue = ""; // Required for Chrome to show alert
    };

    window.addEventListener("beforeunload", handleBeforeUnload);

    return () => {
      window.removeEventListener("beforeunload", handleBeforeUnload);
    };
  }, [hasUnsavedChanges]);

  return hasUnsavedChanges ? (
    <Prompt
      when={hasUnsavedChanges}
      message={t("You have unsaved changes, are you sure you want to leave?")}
    />
  ) : (
    <></>
  );
};

export default UnsavedChangesWarning;
